export default __webpack_public_path__ + "static/media/paymentlinkphone1.8d99d89c.svg";